import React from 'react';
import './Contact.css';

const Contact = () => {
  return (
    <div>
     <section id="contact">
        <div className="row first-section">
          
         
        </div>
      </section>

     
    </div>
  );
};

export default Contact;
